import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfigService } from 'src/app/core/service/config.service';
import { UserInfoService } from 'src/app/shared/services/user-info.service';

@Component({
  selector: 'app-suspend-unsuspend',
  templateUrl: './suspend-unsuspend.component.html',
  styles: [
  ]
})
export class SuspendUnsuspendComponent implements OnInit {
  suspendForm!: FormGroup
  loading: boolean = false;
  constructor(private _formBuilder: FormBuilder,
    private _config: ConfigService,
    public dialogRef: MatDialogRef<SuspendUnsuspendComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _userInfoService: UserInfoService) {

  }

  ngOnInit(): void {
    console.log(this.data.user);
    this.suspendForm = this._formBuilder.group({ reason_suspend: new FormControl('', [Validators.required]) })
  }

  OnSuspend() {
    if (this.suspendForm.invalid) {
      return;
    }
    this.loading = true;
    this._userInfoService.OnSuspendUser({ ...this.suspendForm.value }, this.data.user.id).subscribe({
      next: (res) => {
        this.loading = false;
        this._config.toastrService.success(res.message);
        this.dialogRef.close(true);
      },
      error: (err) => {
        this.loading = false;
        this._config.showErrors(err);
      }
    })
  }

  OnUnsuspend() {
    this.loading = true;
    this._userInfoService.OnUnsuspendUser(this.data.user.id).subscribe({
      next: (res) => {
        this.loading = false;
        this._config.toastrService.success(res.message);
        this.dialogRef.close(true);
      },
      error: (err) => {
        this.loading = false;
        this._config.showErrors(err);
      }
    })
  }
}
